module.exports = __webpack_public_path__ + "static/media/hot11.0d1060c4.jpg";